import { locales, getLocalized, validateLocale } from '../locales';
function dayNameBuilder({
  format,
  locale
}) {
  const requestedLocale = getLocalized(locale);
  const validLocale = validateLocale(locale);
  let weekStartsOn = locales[validLocale].options && locales[validLocale].options.weekStartsOn || 0;
  const days = [];
  for (let d = 0; d < 7; d++) {
    days.push(requestedLocale.day(d, {
      width: format
    }));
  }
  while (weekStartsOn > 0) {
    days.push(days.shift());
    weekStartsOn--;
  }
  return days;
}
export default dayNameBuilder;